<template>
  <div class="mt-3">
      <router-view></router-view>
    </div>
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Accueil",
          icon: "bi bi-phone-fill",
          route: "mobile-home-index",
        },
        {
          label: "Crédits",
          icon: "bi bi-credit-card",
          route: "mobile-credits-index",
        },
        {
          label: "Achats",
          icon: "bi bi-cart-dash",
          route: "mobile-purchases-index",
        },
        {
          label: "Paiements",
          icon: "bi bi-cash-stack",
          route: "mobile-payments-customers-index",
        },
        {
          label: "Ventes",
          icon: "bi bi-bag-check",
          route: "mobile-sales-index",
        },
        {
          label: "Stocks",
          icon: "bi bi-box-seam",
          route: "mobile-stocks-index",
        },
      ],
    };
  },
};
</script>
